import { Link } from "react-router-dom";
import PostTag from "./PostTag";
import styles from "./PostRow.module.css";

export default function PostRow({ post, variant = "writing" }) {
  if (variant === "home") {
    return (
      <Link to={`/writing/${post.slug}`} className={styles.blogRow}>
        <div className={styles.blogLeft}>
          <div className={styles.tagRow}>
            {post.tags.map((t) => <PostTag key={t} tag={t} />)}
          </div>
          <p className={styles.blogTitle}>{post.title}</p>
          <p className={styles.postExcerpt}>{post.excerpt}</p>
        </div>
        <span className={styles.postMeta}>{post.date}</span>
        <span className={styles.postArrow}>→</span>
      </Link>
    );
  }

  return (
    <Link to={`/writing/${post.slug}`} className={styles.postRow}>
      <span className={styles.postDate}>{post.date}</span>
      <div className={styles.postMid}>
        <div className={styles.tagRow}>
          {post.tags.map((t) => <PostTag key={t} tag={t} />)}
        </div>
        <p className={styles.postTitle}>{post.title}</p>
        <p className={styles.postExcerpt}>{post.excerpt}</p>
      </div>
      <span className={styles.postRead}>{post.readTime}</span>
      <span className={styles.postArrow}>→</span>
    </Link>
  );
}
